import { LoadingSpinner } from "../../core/components/LoadingSpinner";
import { useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';
import { Select, propStyling, tombac } from 'tombac';
import { ChevronSLeftIcon, ChevronSRightIcon } from 'tombac-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const pageSizes = [20, 50, 100, 200];
export function getNearestPageSize(size) {
  return pageSizes.reduce((prev, curr) => Math.abs(curr - size) < Math.abs(prev - size) ? curr : prev);
}
const PaginationText = styled.div.withConfig({
  displayName: "Pagination__PaginationText"
})(["", ";margin-right:", ";& > b{font-weight:700;}"], tombac.altText({
  color: tombac.color('neutral', 700),
  fontSize: 12
}), tombac.space(1));
export const PaginationContainer = styled.div.withConfig({
  displayName: "Pagination__PaginationContainer"
})(["display:flex;align-items:center;.pagination{display:inline-block;margin:0 0 0 auto;padding:0;list-style:none;user-select:none;.pagination-item{display:inline;margin:0 2px;}.pagination-link{display:inline-block;vertical-align:middle;padding:2px 8px;", ";cursor:pointer;}.pagination-item.pagination-item--active .pagination-link,.pagination-item.pagination-item--active .pagination-link:hover,.pagination-item.pagination-item--active .pagination-link:focus{color:", ";cursor:default;font-weight:bold;background:none;}.pagination-item .pagination-link:hover{background:", ";border-radius:20px;}.pagination-link--next,.pagination-link--prev{font-size:16px;}.pagination-item.pagination-item--disabled .pagination-link{cursor:not-allowed;background:none;}.pagination-item.pagination-item--disabled svg{color:", ";}.pagination-item svg{color:", ";}.pagination-item:last-child .pagination-link,.pagination-item:first-child .pagination-link{padding:0 1px;}.pagination-break{display:inline-block;}}", ""], tombac.text({
  color: tombac.color('neutral', 700),
  fontSize: 12
}), tombac.color('primary', 500), tombac.color('neutral', 400), tombac.color('neutral', 500), tombac.color('primary', 500), propStyling);
const perPageOptions = pageSizes.map(size => ({
  value: size,
  label: size.toString()
}));
const defaultPage = {
  index: 0,
  size: 20
};
export const Pagination = ({
  itemCount,
  onPageChange,
  page = defaultPage,
  showItemsPerPage = true,
  isListFetching = null,
  ...stylingProps
}) => {
  const start = page.index * page.size + 1;
  const maxEnd = (page.index + 1) * page.size;
  const end = maxEnd > itemCount ? itemCount : maxEnd;
  const pageCount = Math.ceil(itemCount / page.size);
  useEffect(function validatePage() {
    if (page.index > 0 && page.index >= pageCount) {
      onPageChange({
        ...page,
        index: Math.max(0, pageCount - 1)
      });
    }
  }, [page, pageCount]);
  const perPageSelectedOption = perPageOptions.find(o => o.value === page.size);
  if (itemCount === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(PaginationContainer, {
    ...stylingProps,
    "data-sentry-element": "PaginationContainer",
    "data-sentry-component": "Pagination",
    "data-sentry-source-file": "Pagination.tsx",
    children: [showItemsPerPage && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PaginationText, {
        children: /*#__PURE__*/_jsx("b", {
          children: "Items per page"
        })
      }), ' ', /*#__PURE__*/_jsx(Select, {
        $w: "11sp",
        $mr: "1sp",
        size: "s",
        onChange: option => {
          onPageChange({
            ...page,
            size: option.value
          });
        },
        options: perPageOptions,
        value: perPageSelectedOption
      }), ' ', /*#__PURE__*/_jsxs(PaginationText, {
        children: [start, "-", end, " of ", itemCount, " items"]
      }), isListFetching && /*#__PURE__*/_jsx(LoadingSpinner, {
        size: 1,
        $justifyContent: "left"
      })]
    }), pageCount > 1 && /*#__PURE__*/_jsx(ReactPaginate, {
      pageCount: pageCount,
      pageRangeDisplayed: 5,
      marginPagesDisplayed: 1,
      forcePage: page.index,
      containerClassName: "pagination",
      pageClassName: "pagination-item",
      pageLinkClassName: "pagination-link",
      activeClassName: "pagination-item--active",
      disabledClassName: "pagination-item--disabled",
      previousClassName: "pagination-item",
      nextClassName: "pagination-item",
      previousLinkClassName: "pagination-link ",
      nextLinkClassName: "pagination-link",
      breakClassName: "pagination-break",
      previousLabel: /*#__PURE__*/_jsx(ChevronSLeftIcon, {}),
      nextLabel: /*#__PURE__*/_jsx(ChevronSRightIcon, {}),
      onPageChange: v => {
        onPageChange({
          ...page,
          index: v.selected
        });
      }
    })]
  });
};